(function () {
    'use strict';
    'ngInject';

    angular.module('app.ctrls').controller('SignUpCtrl', signUpCtrl);

    function signUpCtrl(
        $scope,
        $rootScope,
        $mdDialog,
        $location,
        $window,
        $routeParams,
        UsersAPIService,
        StripeCheckoutAPIService,
        vcRecaptchaService,
        blockUI
    ) {
        $rootScope.showHeader = false;
        $scope.showRegistrationForm = true;
        $scope.recaptchaPublicKey = '6LdxWcYUAAAAAE8LVGxSGubGleKfjYF5LqjKR9HP';
        $scope.managedBy = $location.search().mngBy;
        $scope.storeType = $scope.managedBy === 'chipadmin' ? 'Custom' : 'WooCommerce';
        $scope.storeUrlRegex = '';
        //load store type via querystring
        if ($routeParams.storeType) {
            $scope.storeType = $routeParams.storeType;
        }

        $scope.storeChanged = function () {
            switch ($scope.storeType) {
                case 'Shopify':
                    $scope.storeUrlRegex = /^[a-zA-Z-0-9]+\.myshopify\.com$/;
                    break;

                case 'Amazon':
                    $scope.storeUrlRegex = /^[a-zA-Z-0-9]+$/;
                    break;

                default:
                    $scope.storeUrlRegex = /^(https?:\/\/)?(www\.)?[-a-zA-Z0-9@%._\+~#=]{1,256}\.[a-zA-Z0-9()]{2,63}\b([-a-zA-Z0-9()@%_\+.~#?&//=]*)$/;
                    break;
            }
        };
        $scope.storeChanged();

        $scope.signUp = function () {
            if (vcRecaptchaService.getResponse() === '') {
                $mdDialog.show(
                    $mdDialog
                        .alert()
                        .parent(document.body)
                        .clickOutsideToClose(true)
                        .title('User creation')
                        .textContent('Resolve the captcha first')
                        .ok('OK!')
                );
            } else {
                if ($scope.password === $scope.passwordConfirmation) {
                    blockUI.start();
                    UsersAPIService.registerUser(
                        $scope.name,
                        $scope.username,
                        $scope.email,
                        $scope.password,
                        $scope.passwordConfirmation,
                        $scope.managedBy,
                        $scope.storeType,
                        $scope.storeUrl,
                        vcRecaptchaService.getResponse()
                    )
                        .then(function () {
                            // Show confirmation message
                            $scope.showRegistrationForm = false;
                            const excludedStoreTypes = ['Shopify'];
                            if (!excludedStoreTypes.includes($scope.storeType)) {
                                const data = {
                                    storeType: $scope.storeType
                                };
                                StripeCheckoutAPIService.createCheckoutSession($scope.username, data).then(
                                    (response) => ($window.location.href = response)
                                );
                            }
                            blockUI.stop();
                        })
                        .catch(function (err) {
                            blockUI.stop();
                            vcRecaptchaService.reload();
                            $mdDialog.show(
                                $mdDialog
                                    .alert()
                                    .parent(document.body)
                                    .clickOutsideToClose(true)
                                    .title('User creation')
                                    .textContent(err.data)
                                    .ok('OK!')
                            );
                        });
                } else {
                    $mdDialog.show(
                        $mdDialog
                            .alert()
                            .parent(document.body)
                            .clickOutsideToClose(true)
                            .title('Password error')
                            .textContent("Passwords don't match")
                            .ok('OK!')
                    );
                }
            }
        };
    }
})();
